import { FunctionComponent, useState, useEffect } from 'react'
import { Text } from '@conexasaude/conexa-hero'
import LoadingPage from '@/components/LoadingPage'
import { Illustration } from '@/components/HideIllustrationsExternal'
import { useRealtimeAttendanceContext } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import { useNavigation } from '@/hooks/useNavigation'
import { convertStringIntoDateTime } from '@/utils/date'
import { useStyles } from './styles'
import { useValidateRealtime } from '@/hooks/useValidateRealtime'

const MagicLInkWithoutAttendance: FunctionComponent = () => {
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigation()
  const { hasValidatedRealtime, hasRealtimeAttendances } = useValidateRealtime({
    onRealtimeWithoutAttendances: () => navigate('/'),
  })
  const styles = useStyles()

  const {
    realtimeAttendance: { scheduled },
  } = useRealtimeAttendanceContext()

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 30000)
  }, [])

  useEffect(() => {
    if (!hasValidatedRealtime) return

    const notExpiredAttendances = scheduled?.filter(attendance => {
      const attendanceDate = convertStringIntoDateTime(
        attendance?.scheduledDate,
      )
      const attendanceDateDiffInMinutes = attendanceDate.diffNow().as('minutes')

      return attendanceDateDiffInMinutes > -20
    })

    if (notExpiredAttendances?.length > 0) {
      const attendanceId = notExpiredAttendances[0]?.id

      navigate(`/atendimento-agendado/sala-de-espera/${attendanceId}`)

      return
    }

    navigate('/')
  }, [hasRealtimeAttendances, hasValidatedRealtime, navigate, scheduled])

  if (isLoading) {
    return (
      <LoadingPage
        withoutNav
        text="Um instante, estamos validando o seu atendimento."
      />
    )
  }

  return (
    <div css={styles.validateWrapper}>
      <div css={styles.mainWrapper}>
        <Text renderAs="h2">
          Não há atendimento agendado no momento ou o atendimento já foi
          finalizado pelo profissional de saúde.
        </Text>

        <Illustration name="medic-error" width="224px" height="224px" />
      </div>
    </div>
  )
}

export default MagicLInkWithoutAttendance
